<template>
  <div>
    <v-tooltip v-if="$security.checkUserAccess('UpdateTask')" bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          class="mr-1"
          icon
          x-small
          v-bind="attrs"
          v-on="on"
          @click="$emit('edit')"
        >
          <v-icon small>mdi-pencil</v-icon>
        </v-btn>
      </template>
      <span>{{ $t("task.lblEditTask") }}</span>
    </v-tooltip>
    <v-tooltip v-if="$security.checkUserAccess('DeleteTask')" bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          x-small
          icon
          v-bind="attrs"
          v-on="on"
          class="mr-1"
          @click="$emit('delete')"
        >
          <v-icon small>mdi-delete</v-icon>
        </v-btn>
      </template>
      <span>{{ $t("task.lblDeleteTask") }}</span>
    </v-tooltip>
    <v-tooltip v-if="$security.checkUserAccess('UpdateTask')" bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          x-small
          icon
          v-bind="attrs"
          v-on="on"
          @click="$emit('sendEmail')"
        >
          <v-icon small>mdi-email-outline</v-icon>
        </v-btn>
      </template>
      <span>{{ $t("task.lblEmailNotification") }}</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  name: "ActionTemplate",
};
</script>

<style>
</style>